var _path, _path2;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var AppsComments = function AppsComments(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsxs("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: [_path || (_path = /*#__PURE__*/_jsx("path", {
      d: "M7 9a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1ZM8 12a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2H8Z",
      fill: "none",
      className: "tw-fill-current"
    })), _path2 || (_path2 = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.172 5.172A4 4 0 0 1 7 4h10a4 4 0 0 1 4 4v6a4 4 0 0 1-4 4h-1.586l-2.707 2.707a1 1 0 0 1-1.414 0L8.586 18H7a4 4 0 0 1-4-4V8a4 4 0 0 1 1.172-2.828ZM7 6a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2a1 1 0 0 1 .707.293L12 18.586l2.293-2.293A1 1 0 0 1 15 16h2a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2H7Z",
      fill: "none",
      className: "tw-fill-current"
    }))]
  });
};
export default AppsComments;